import { createFileRoute } from "@tanstack/react-router";
import { PatientIndexPane } from "@/features/patients";

/**
 * `/patients` with no id — the nobody-chosen pane.
 *
 * The rail and its search are the parent's (`patients.tsx`); this route is
 * only the sentence the POC draws beside the rail when nobody is chosen.
 * What was typed and what was chosen do not belong in the page URL
 * (`DECISIONS.md` 21-09-2026 and 05-10-2026), so there are no search params
 * here either.
 */
export const Route = createFileRoute("/_authenticated/patients/")({
  component: PatientIndexPane,
});
